export default __webpack_public_path__ + "492cfafc505ebf85bacbb6a9598a594c.png";